// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PageSvg from '@rsuite/icon-font/lib/file/Page';
var Page = createSvgIcon({
  as: PageSvg,
  ariaLabel: 'page',
  category: 'file',
  displayName: 'Page'
});
export default Page;